"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const hex_1 = require("../hex");
function anyToBN(data = 0, options = {}) {
    options = Object.assign({ defaults: null }, options);
    let result = options.defaults;
    switch (typeof data) {
        case 'number':
            result = new bn_js_1.default(data, 10);
            break;
        case 'string':
            const hex = hex_1.prepareHex(data);
            if (hex) {
                result = new bn_js_1.default(hex, 16);
            }
            break;
        case 'object':
            if (bn_js_1.default.isBN(data)) {
                result = data;
            }
            else if (Buffer.isBuffer(data)) {
                result = new bn_js_1.default(data.toString('hex'), 16);
            }
            break;
    }
    return result;
}
exports.anyToBN = anyToBN;
//# sourceMappingURL=utils.js.map